export enum ContractRetentionApiRoutes {
  ById = '/contract-retentions/:id',
}
